const api_url = 'https://48gfivc83f.execute-api.us-east-1.amazonaws.com/api/api'
const file_url = 'https://48gfivc83f.execute-api.us-east-1.amazonaws.com/api'
const commentLimit = 250
const max_file_size = 10 * 1000 * 1000

export { api_url, commentLimit, file_url, max_file_size }
